module.exports = __webpack_public_path__ + "static/media/world-market-small.060d959d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/world-market-small.png
// module id = 675
// module chunks = 27